import { Aspect } from '@teambit/harmony';

export const ObjectsAspect = Aspect.create({
  id: 'teambit.scope/objects',
});
